module.exports = __webpack_public_path__ + "static/media/plus-blue.899a4aa9.svg";